import React, { useEffect, useState } from 'react';
import posthog from 'posthog-js';

export const PosthogScript = () => {
  useEffect(() => {
    posthog.init(process.env.VITE_POSTHOG_KEY, {
      api_host: process.env.VITE_POSTHOG_HOST,
      person_profiles: 'always', //'identified_only' or 'always' to create profiles for anonymous users as well
    });
  }, []);

  return null;
};
